import {
  Button,
  CloseIcon,
  TransparentButton,
  Typography,
} from '@libs/components';
import { hexColorWithOpacity } from '@libs/helpers';
import { ReferralGift } from 'src/assets';
import styled from 'styled-components';
import Bullets from '../bullets/Bullets';

export const Container = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  background: linear-gradient(126deg, #191c7a 0%, #3d62d7 100%);
  height: 20rem;
  width: 100%;
`;
export const InsideContainer = styled.div`
  position: relative;
  padding: 1.4rem 1.4rem 1.9rem;
  width: 100%;
  height: 100%;
  background-image: url(${ReferralGift});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: bottom;
  background-size: 14rem;
  display: flex;
  flex-direction: column;
`;
export const CustomBullets = styled(Bullets)`
  background-color: ${({ theme }) => theme.colors.surface.default};
`;
export const Title = styled(Typography)`
  margin-bottom: 0.8rem;
`;
export const CustomButton = styled(Button)`
  margin-top: auto;
  min-width: 12.7rem;
  width: max-content;
  padding: 0 1.5rem;
`;
export const CloseButton = styled(TransparentButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.6rem;
  height: 3.6rem;

  background-color: ${({ theme }) =>
    hexColorWithOpacity(theme.colors.surface.default, 12)};
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  border: 1px solid
    ${({ theme }) => hexColorWithOpacity(theme.colors.surface.default, 24)};
  position: absolute;
  top: 1.4rem;
  right: 1.4rem;
`;
export const FlexContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: auto;
`;
export const AssetCode = styled(Typography)`
  margin-bottom: 0.4rem;
  padding-left: 0.2rem;
`;

export const CustomCloseIcon = styled(CloseIcon)`
  width: 1.25rem;
  height: 1.25rem;
  path {
    stroke-width: 1;
  }
`;
export const CustomDescription = styled(Typography)`
  margin-bottom: 2rem;
  max-width: 90%;
`;
